module.exports = __webpack_public_path__ + "assets/img/close-white.fd7abe7c.svg";